/** Strip leftover markdown heading marks from stored chat titles. */
export function displayChatTitle(title, fallback = 'Untitled chat') {
  const cleaned = String(title || '')
    .trim()
    .replace(/^#{1,6}(?:\s+|$)/, '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/__(.+?)__/g, '$1')
    .replace(/`+/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  return cleaned || fallback;
}
